import React, { Fragment } from 'react'
import FilterPopout from './FilterPopout'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import FilterIcon from '@tecuity/sos-icons/react/filter'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import { Spinner } from 'components/Loaders/Loaders'
import deepEqual from 'deep-equal'
import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import ReactMarkdown from "react-markdown";
import { announce } from '../../actions'
import { connect } from 'react-redux'

const SEARCH_CONFIG = {
  type: 'text',
  name: 'SEARCH',
  defaultValue: '',
  label: 'Search',
}

export class TableControls extends React.Component {
  state = {
    searchValue: '',
    filterOpen: false,
  }
  onSearchChange = (e) => {
    const searchValue = e.target.value
    this.setState({ searchValue })
  }
  search = () => {
    this.props.onFilterChange({
      ...this.props.filters,
      SEARCH: this.state.searchValue,
    })
    this.setState({ searchValue: '' })
  }
  toggleFilter = () => {
    this.state.filterOpen ? this.unregisterEscapeListener() : this.registerEscapeListener()
    this.setState((state) => ({
      filterOpen: !state.filterOpen,
    }))
  }
  revertFilter = (name) => {
    const targetFilter = [...this.props.filterTemplates, SEARCH_CONFIG].find(
      (ft) => ft.name === name
    )
    this.props.onFilterChange({
      ...this.props.filters,
      [name]: targetFilter.defaultValue,
    })
  }
  parseDate = (date) => {
    const parsed = new Date(date)
    return isValid(parsed) ? format(parsed, 'MM/dd/yyyy') : ''
  }
  getChipValueByType = (value = '', filter) => {
    switch (filter.type) {
      case 'select':
      case 'radio':
        return (filter.options.find((opt) => opt.value.toString() === value.toString()) || {}).label
      case 'checkbox':
        return value ? 'Yes' : 'No'
      case 'dateRange':
        const startDate = this.parseDate(value.start)
        const endDate = this.parseDate(value.end)
        return `${startDate || 'Today'} - ${endDate || 'Today'}`
      default:
        return value
    }
  }
  getFilterChips = () => {
    const { filterTemplates, filters } = this.props
    return [SEARCH_CONFIG, ...filterTemplates].reduce((arr, ft) => {
      if (filters[ft.name] && !deepEqual(filters[ft.name], ft.defaultValue)) {
        return [
          ...arr,
          {
            label: ft.label,
            value: this.getChipValueByType(filters[ft.name], ft),
            name: ft.name,
          },
        ]
      }
      return arr
    }, [])
  }
  checkForSubmit = (e) => {
    if (e.keyCode === 13) {
      this.search()
    }
  }  
    
    registerEscapeListener = () => {
      document.addEventListener('keydown', this.handleKeyDown)
    }
    unregisterEscapeListener = () => {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
    handleKeyDown = (e) => {
      if (e.keyCode === 27) {
        this.toggleFilter()
      }
    }
    handleHelpFocus = () => {
      this.positionTooltip()
      this.props.announce(this.props.helpText)
    }
    positionTooltip() {
      const target = document.getElementById('help-icon');
      const tooltip = document.getElementById('tooltip');
      const rect = target.getBoundingClientRect();

      // Check if the element is too close to the left edge of the viewport
      if (rect.right + tooltip.offsetWidth < 200) {
          tooltip.classList.add('move-right');
      } else {
          tooltip.classList.remove('move-right');
      }
    }
  render() {
    const {
      filterTemplates,
      filters,
      onFilterChange,
      title,
      allowSearch,
      loading,
      searchPlaceholder,
      description,
      showHelpText,
      helpText,
      helpLabel,
    } = this.props
    const calculatedDescription = description
    return (
      <div className="table-controls-wrapper">
        <div className="toolbar">
          {title && (
            <h2>
              {title}
              {loading && (
                <div className="loading-wrapper">
                  <Spinner size="small" themeColor="medium-neutral" />
                </div>
              )}
            </h2>
          )}
          <div className="filter-wrapper">
            {showHelpText ? (
              <div tabIndex={0} className="help-icon-wrapper" id='help-icon' onFocus={this.handleHelpFocus} onBlur={() => this.positionTooltip()} onMouseOver={() => this.positionTooltip()} onMouseOut={() => this.positionTooltip()}>
                <span className="info-help-text" id='tooltip' aria-hidden="true" role="alert" aria-live="assertive">
                  <span>
                    <b>{helpLabel}</b>
                  </span>
                  <br /><br />
                  <span>{helpText}</span>
                </span>
                <span className="info-icon" aria-hidden="true">
                  i
                </span>
              </div>
            ) : null}
            {allowSearch && (
              <input
                type="text"
                className="filter"
                placeholder={searchPlaceholder || 'Search'}
                value={this.state.searchValue}
                onChange={this.onSearchChange}
                onKeyDown={this.checkForSubmit}
                aria-label={searchPlaceholder || 'Search'}
                ref={(r) => (this.searchInput = r)}
              />
            )}
            {allowSearch && (
              <button
                type="button"
                aria-disabled={this.state.searchValue.length === 0}
                className="search btn btn-primary btn-raised"
                aria-label="Execute Search"
                title="Execute Search"
                onClick={this.search}
              >
                  <span className=" visually-hidden">
                    Execute Search
                  </span>
                <SearchIcon />
              </button>
            )}
            {filterTemplates && (
              <button
                type="button"
                className="search btn btn-primary btn-raised"
                aria-label="Filter"
                title="Filter"
                onClick={this.toggleFilter}
                ref={(r) => (this.filterButton = r)}
              >
                  <span className=" visually-hidden">
                    Filter
                  </span>
                <FilterIcon aria-hidden className="filter-icon" />
              </button>
            )}
            {filterTemplates && this.state.filterOpen && (
              <FilterPopout
                onChange={onFilterChange}
                filterTemplates={filterTemplates}
                filters={filters}
                onRequestClose={this.toggleFilter}
              />
            )}
          </div>
        </div>
        {calculatedDescription ? <ReactMarkdown className="description" source={calculatedDescription}/> : null}
        <div className="filter-chips">
          {filterTemplates &&
            this.getFilterChips().map((fc) => (
              <FilterChip
                label={fc.label}
                value={fc.value}
                name={fc.name}
                onDeleteRequested={this.revertFilter}
                key={fc.name}
              />
            ))}
        </div>
      </div>
    )
  }
}

const FilterChip = ({ label, value, name, onDeleteRequested }) => (
  <span className="filter-chip">
    <div className="label">{label}</div>
    <div className="value">{value}</div>
    <button
      type="button"
      aria-label="Remove filter"
      title="Remove filter"
      onClick={() => {
        onDeleteRequested(name)
      }}
    >
      <div className="center">
        <CrossIcon />
      </div>
    </button>
  </span>
)

export default connect(
  null,
  { announce }
)(TableControls)


// WEBPACK FOOTER //
// ./src/components/Table/TableControls.js